export default "https://cdn-static.gokick.com/assets/89c12df47656b56f32e50d5631dab02a560652ab/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";